import { setupWorker } from "msw/browser";
import { authHandlers } from "./auth";
import { customersHandlers } from "./customers";
import { itemsHandlers } from './items'
import { suppliersHandlers } from "./suppliers";
import { ordersHandlers } from "./orders";
import { appointmentsHandlers } from "./appointments";

export const worker = setupWorker(
    ...authHandlers,
    ...customersHandlers,
    ...itemsHandlers,
    ...suppliersHandlers,
    ...ordersHandlers,
    ...appointmentsHandlers
);
